<template>
  <div class="d-flex justify-content-center align-items-center flex-column full-height-class">
    <div class="mb-4 ml-0">
      <i class="fa-solid fa-cog fa-spin fa-5x"></i>
      <i class="fa-solid fa-cog fa-spin fa-5x" style="--fa-animation-direction: reverse"></i>
    </div>
    <span class="typed-text text-center font-weight-bolder h5">{{ loadingText }}</span>
  </div>
</template>

<script>
export default {
  name: 'sistemacpv-loading',
  props: ['loadingText'],
};
</script>

<style scoped>
/* .full-height-class {
  height: calc(100vh - 214px);
} */

.m-cog-second {
  position: absolute;
  margin-top: 18px;
  margin-left: -10px;
}
</style>